var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-spinner",class:_setup.baseSpinnerClasses},[_c('div',{staticClass:"base-spinner__circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }